import { render, staticRenderFns } from "./HotelFacilityList.vue?vue&type=template&id=740cb0df&scoped=true"
import script from "./HotelFacilityList.vue?vue&type=script&lang=js"
export * from "./HotelFacilityList.vue?vue&type=script&lang=js"
import style0 from "./HotelFacilityList.vue?vue&type=style&index=0&id=740cb0df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740cb0df",
  null
  
)

export default component.exports